const languages = {
  en: {
    label: "English",
    // Skrót pokazywany na przycisku zamiast flagi — język to nie kraj,
    // a "EN" czyta się jednoznacznie tam, gdzie flaga GB/US myliła.
    code: "EN",
  },
  pl: {
    label: "Polski",
    code: "PL",
  },
}

export default languages
